import layoutHeaderAside from '@/layouts/HeaderAside'
const meta = { auth: true }
export default {
  path: '/settings',
  meta,
  component: layoutHeaderAside,
  children: [
    {
      path: '/',
      name: 'settings',
      component: () => import('@/pages/settings/index.vue'),
      meta: {
        ...meta,
        title:'个人设置',
        requireAuth: true
      },
      children: [
        {
          path: '/',
          name: 'settings',
          component: () => import('@/pages/settings/index.vue'),
          meta: {
            ...meta,
            title:'个人设置',
            requireAuth: true
          }
        },
        {
          path: '/settings/userInfomaintenance',
          name: 'userInfomaintenance',
          component: () => import('@/pages/settings/userProfile.vue'),
          meta: {
            ...meta,
            title:'用户信息',
            requireAuth: true
          }
        },
        // {
        //   path: '/settings/binding',
        //   name: 'binding',
        //   component: () => import('@/pages/settings/settings-customerRelations.vue'),
        //   meta: {
        //     ...meta,
        //     title:'客户关系',
        //     requireAuth: true
        //   }
        // },
        // {
        //   path: '/settings/crmAdd',
        //   name: 'crmAdd',
        //   component: () => import('@/pages/settings/settings-applyAgency.vue'),
        //   meta: {
        //     ...meta,
        //     title:'申请代理',
        //     requireAuth: true
        //   }
        // },
        // {
        //   path: '/settings/crmAuth',
        //   name: 'crmAuth',
        //   component: () => import('@/pages/settings/settings-auditList.vue'),
        //   meta: {
        //     ...meta,
        //     title:'审核列表',
        //     requireAuth: true
        //   }
        // },
        {
          path: '/settings/bindManage',
          name: 'bindManage',
          component: () => import('@/pages/settings/settings-manageAgency.vue'),
          meta: {
            ...meta,
            title:'经办人管理',
            requireAuth: true
          }
        },
        {
          path: '/settings/changeUser',
          name: 'changeUser',
          component: () => import('@/pages/settings/settings-userSwitching.vue'),
          meta: {
            ...meta,
            title:'用户切换',
            requireAuth: true
          }
        },
        {
          path: '/settings/changeMessage',
          name: 'changeMessage',
          component: () => import('@/pages/settings/settings-passwordModif.vue'),
          meta: {
            ...meta,
            title:'修改密码',
            requireAuth: true
          }
        },
        {
          path: '/settings/receiptInfo',
          name: 'receiptInfo',
          component: () => import('@/pages/settings/receiptInfo.vue'),
          meta: {
            ...meta,
            title:'收货信息',
            requireAuth: true
          }
        },
        {
          path: '/settings/shipmentInfo',
          name: 'shipmentInfo',
          component: () => import('@/pages/settings/shipmentInfo.vue'),
          meta: {
            ...meta,
            title:'发货信息',
            requireAuth: true
          }
        },
        {
          path: '/settings/changePhone',
          name: 'changePhone',
          component: () => import('@/pages/settings/settings-changePhone.vue'),
          meta: {
            ...meta,
            title:'手机号更换',
            requireAuth: true
          }
        },
        {
          path: '/settings/signature',
          name: 'signature',
          component: () => import('@/pages/settings/enterpriseSignature.vue'),
          meta: {
            ...meta,
            title:'企业签章',
            // requireAuth: true
          }
        },
        {
          path: '/settings/driverManagement',
          name: 'driverManagement',
          component: () => import('@/pages/settings/driverManagement.vue'),
          meta: {
            ...meta,
            title:'接取送达司机管理',
            // requireAuth: true
          }
        },
        {
          path: '/settings/kchwh',
          name: 'kchwh',
          component: () => import('@/pages/settings/kchwh.vue'),
          meta: {
            ...meta,
            title:'卡车号维护',
            // requireAuth: true
          }
        },
      ]
    }
  ]
}
